// arrivo Design System — shared font + button tokens
// All components import from here; never duplicate these constants.

export const FONTS = {
  // Logo uses Gulfs Display
  logo: { fontFamily: "'Gulfs Display', 'Batangas', sans-serif" },
  // Headers use Batangas
  heading: { fontFamily: "'Batangas', sans-serif" },
  headingBold: { fontFamily: "'Batangas', sans-serif", fontWeight: 700 },
  headingSemibold: { fontFamily: "'Batangas', sans-serif", fontWeight: 600 },
  // Body text uses Raleway
  body: { fontFamily: "'Raleway', sans-serif" },
  bodyBold: { fontFamily: "'Raleway', sans-serif", fontWeight: 700 },
};

// Brand palette:
//   Light Blue  #a7d8db  — selected fill
//   Blue-Gray   #313143  — selected border & text
//   Hover tint  #e8f4f5  — light touch on hover

// Standard button style system
// Titles: Batangas Bold | Body/buttons: Raleway
export const BTN = {
  // Primary CTA — solid blue-gray, full-width, bold
  primary: 'w-full py-3.5 bg-[#313143] text-white font-bold rounded-xl hover:bg-[#3d3d52] hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed text-lg',
  // Secondary — outline style
  secondary: 'px-4 py-2.5 bg-white text-gray-700 border-2 border-gray-200 rounded-xl font-medium hover:border-[#a7d8db] hover:bg-[#e8f4f5] transition-all',
  // Danger — red
  danger: 'px-4 py-2.5 bg-red-50 text-red-600 border-2 border-red-200 rounded-xl font-medium hover:bg-red-100 hover:border-red-300 transition-all',
  // Pill toggle — for multi-select options (dietary, hotel area, etc.)
  pill: (selected) => `px-4 py-2.5 rounded-xl border-2 font-medium transition-all ${
    selected
      ? 'border-[#313143] bg-[#a7d8db] text-[#313143] shadow-md'
      : 'border-gray-200 bg-white text-gray-700 hover:border-[#a7d8db] hover:bg-[#e8f4f5]'
  }`,
  // Card toggle — bordered card for single/multi select (pace, companions, transport, etc.)
  card: (selected) => `p-4 rounded-xl border-2 font-medium transition-all ${
    selected
      ? 'border-[#313143] bg-[#a7d8db] text-[#313143] shadow-md'
      : 'border-gray-200 bg-white hover:border-[#a7d8db] hover:bg-[#e8f4f5]'
  }`,
  // Small chip — compact (travel class, quick-city, etc.)
  chip: (selected) => `px-3 py-2.5 rounded-xl border-2 font-medium transition-all text-sm ${
    selected
      ? 'border-[#313143] bg-[#a7d8db] text-[#313143] shadow-sm'
      : 'border-gray-200 bg-white text-gray-700 hover:border-[#a7d8db] hover:bg-[#e8f4f5]'
  }`,
  // Icon button — small, circular/square
  icon: 'p-2 rounded-lg hover:bg-gray-100 transition-colors',
  // Send button — round teal gradient
  send: 'w-14 h-14 rounded-full bg-[#313143] flex items-center justify-center text-white hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100',
};
